export default __webpack_public_path__ + "static/media/impact.660cd862.jpg";